module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rev Musandiwa Patrick Nemabubuni is a reformed Christian husband to Meriam and a father to Emmanuel, Eternity and Ezra. Patrick completed his Master of Arts in Biblical Counselling at The Master’s University in California, USA, on 4 June 2018. On 6 September 2016, he became the first Black African to be accredited as a biblical counsellor by the highest authority (board) of biblical counsellors in the world called the Association of Certified Biblical Counsellors USA (www.biblicalcounseling.com). Patrick is an author and a teaching pastor in a reformed Christian church called Glorious Fellowship Church in Pretoria, South Africa.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0